export default __webpack_public_path__ + "static/media/CMR.f9f75d03.svg";